<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'仙剑一周年报告'"></div>
    <div class="home-wrapper-3">
      <div class="triennial-home-page" id="triennial-home-page">
        <div class="main">
          <div class="container">
            <div class="swiper-bg">
              <div class="swiper-bg-warp">
                <!-- 禁用鼠标拖动swiper-no-swiping -->
                <div class="swiper-wrapper swiper-no-swiping">
                  <div class="swiper-slide">
                    <div class="content-box">
                      <canvas id="canvas"></canvas>
                      <div class="tips"></div>
                      <div class="logo"></div>
                      <div
                        class="rules"
                        @click="isShowActivityDetailDialog"
                      ></div>
                      <div
                        class="music"
                        v-if="isShowMusicBtn"
                        @click="musicClick(false)"
                      ></div>
                      <div
                        class="close_music"
                        v-if="!isShowMusicBtn"
                        @click="musicClick(true)"
                      ></div>
                      <div class="download" @click="gotoWeb"></div>
                      <div
                        :class="userInfo.role_id ? 'logout' : 'login'"
                        @click="openLoginOS"
                      ></div>
                      <div class="title"></div>
                      <div class="subtitle"></div>
                      <div class="server_name">
                        {{ userInfo.server_name }} {{ userInfo.role_name }}
                      </div>
                      <div class="start" @click.stop="nextPage"></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="first-act-box">
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 1"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[1].isPlayAnimate
                              ? 'inbetweening_left animated fadeIn delay125s'
                              : 'inbetweening_left'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[1].isPlayAnimate
                              ? 'inbetweening_right animated fadeIn delay125s'
                              : 'inbetweening_right'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[1].isPlayAnimate
                              ? 'dialog_box_1 animated fadeIn delay125s'
                              : 'dialog_box_1'
                          "
                        >
                          <div class="ysz"></div>
                          <p class="p_mt">
                            <span>{{
                              formatDate(
                                user_activity.play_info.registerdate
                              )[0]
                            }}</span
                            >年<span>{{
                              formatDate(
                                user_activity.play_info.registerdate
                              )[1]
                            }}</span
                            >月<span>{{
                              formatDate(
                                user_activity.play_info.registerdate
                              )[2]
                            }}</span
                            >日， <br />你从余杭客栈苏醒。
                          </p>
                          <p class="p_mt1">
                            闯荡<span>{{
                              user_activity.play_info.logindays
                            }}</span
                            >天，<br /><span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.onlinehours
                              )
                            }}</span
                            >小时
                          </p>
                        </div>
                        <div
                          :class="
                            isAnimateList[1].isPlayAnimate
                              ? 'dialog_box_2 animated fadeIn delay125s'
                              : 'dialog_box_2'
                          "
                        >
                          <p>
                            付出<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.vitconsume
                              )
                            }}</span
                            >体力斩妖除魔，<br />当前总战力<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.MaxFap
                              )
                            }}</span
                            >万，<br />超过全服<span
                              >{{ user_activity.max_fap_proportion }}%</span
                            >大侠
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="second-act-box">
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 2"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[2].isPlayAnimate
                              ? 'inbetweening animated fadeIn delay125s'
                              : 'inbetweening'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[2].isPlayAnimate
                              ? 'dialog_box animated fadeIn delay125s'
                              : 'dialog_box'
                          "
                        >
                          <div class="ysz"></div>
                          <p class="p_mt">
                            <span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.recruitxiyou
                              )
                            }}</span
                            >位稀有侠客，<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.recruityinyang
                              )
                            }}</span
                            >位阴阳侠客，<br /><span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.star15
                              )
                            }}</span
                            >位满星侠客。<br />其中<span>{{
                              user_activity.play_info.hero.name
                            }}</span
                            >战力高达<span
                              >{{
                                formatNumberWithCommas(
                                  user_activity.play_info.HeroMaxFap
                                )
                              }}万</span
                            >，<br />超过全服<span
                              >{{
                                user_activity.hero_max_fap_proportion
                              }}%</span
                            >侠客。
                          </p>
                          <p class="p_mt1">
                            你们并肩作战，<br />共计培养飞升装备<span>{{
                              user_activity.play_info.equipnum
                            }}</span
                            >件，<br />其中<span
                              v-if="user_activity.play_info.BaptismEntryStrname"
                              >“{{
                                user_activity.play_info.BaptismEntryStrname
                              }}”</span
                            >绝世词条达<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.BaptismEntryStrnum
                              )
                            }}</span
                            >个。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="third-act-box">
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 3"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[3].isPlayAnimate
                              ? 'inbetweening animated fadeIn delay125s'
                              : 'inbetweening'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[3].isPlayAnimate
                              ? 'dialog_box animated fadeIn delay125s'
                              : 'dialog_box'
                          "
                        >
                          <div class="ysz"></div>
                          <div class="qiyuanfu p_mt">
                            <img
                              src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/third/qiyuanfu.png"
                            />
                            <p>
                              祈愿符 ×
                              <span>{{
                                formatNumberWithCommas(
                                  user_activity.play_info.qiyuanfuconsume
                                )
                              }}</span>
                            </p>
                          </div>
                          <div class="wuxishi">
                            <img
                              src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/third/wuxishi.png"
                            />
                            <p>
                              五系招募石 ×
                              <span>{{
                                formatNumberWithCommas(
                                  user_activity.play_info.wuxizhaoconsume
                                )
                              }}</span>
                            </p>
                          </div>
                          <div class="zhizun">
                            <img
                              src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/third/zhizun.png"
                            />
                            <p>
                              至尊召唤符 ×
                              <span>{{
                                user_activity.play_info.zhizunzhaoconsume
                              }}</span>
                            </p>
                          </div>
                          <div class="jinlong">
                            <img
                              src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/third/jinlong.png"
                            />
                            <p>
                              金龙 ×
                              <span>{{
                                formatNumberWithCommas(
                                  user_activity.play_info.diamondconsume
                                )
                              }}</span>
                            </p>
                          </div>
                          <p class="p_mt1">
                            金龙消耗超全服<span
                              >{{
                                user_activity.diamondconsume_proportion
                              }}%</span
                            >的大侠
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div
                      class="fourth-act-box"
                      v-if="
                        user_activity.play_info &&
                        user_activity.play_info.petScore &&
                        user_activity.play_info.petScore != 0
                      "
                    >
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 4"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[4].isPlayAnimate
                              ? 'inbetweening animated fadeIn delay125s'
                              : 'inbetweening'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[4].isPlayAnimate
                              ? 'dialog_box_1 animated fadeIn delay125s'
                              : 'dialog_box_1'
                          "
                        >
                          <div class="ysz"></div>
                          <p class="p_mt">
                            <!-- 有酣战之技能，修仙灵之品质。<br /> -->
                            如影随形，共度难关。
                          </p>
                        </div>
                        <div
                          :class="
                            isAnimateList[4].isPlayAnimate
                              ? 'dialog_box_2 animated fadeIn delay125s'
                              : 'dialog_box_2'
                          "
                        >
                          <p>
                            您的最强幻灵已达<span>{{
                              user_activity.play_info.petstar - 5
                            }}</span
                            >火<br />其评分值高达<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.petScore
                              )
                            }}</span
                            >，<br />超过全服<span
                              >{{ user_activity.pet_score_propotion }}%</span
                            >幻灵
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="fifth-act-box">
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 5"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[5].isPlayAnimate
                              ? 'inbetweening_left animated fadeIn delay125s'
                              : 'inbetweening_left'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[5].isPlayAnimate
                              ? 'inbetweening_right animated fadeIn delay125s'
                              : 'inbetweening_right'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[5].isPlayAnimate
                              ? 'dialog_box_1 animated fadeIn delay125s'
                              : 'dialog_box_1'
                          "
                        >
                          <div class="ysz"></div>
                          <p class="p_mt">
                            比武大会最高积分达<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.CurScore
                              )
                            }}</span
                            ><br />抢占琉璃矿<span>{{
                              user_activity.play_info.minewar
                            }}</span
                            >次，<br />防守成功<span>{{
                              user_activity.play_info.minewar_IsSuccess
                            }}</span
                            >次
                          </p>
                        </div>
                        <div
                          :class="
                            isAnimateList[5].isPlayAnimate
                              ? 'dialog_box_2 animated fadeIn delay125s'
                              : 'dialog_box_2'
                          "
                        >
                          <p>
                            冲上神魔之井第<span>{{
                              user_activity.play_info.maxlayerid
                            }}</span
                            >层<br /><span>{{
                              user_activity.play_info.TotalPassNum
                            }}</span
                            >次通关寻仙路，<br />对首领伤害最高达<span>{{
                              formatNumberWithCommas(
                                user_activity.play_info.MaxDamage
                              )
                            }}</span
                            >万<br />伤害最高超过全服<span
                              >{{ user_activity.max_damage_propotion }}%</span
                            >的大侠
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="sixth-act-box">
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 6"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[6].isPlayAnimate
                              ? 'inbetweening animated fadeIn delay125s'
                              : 'inbetweening'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[6].isPlayAnimate
                              ? 'dialog_box animated fadeIn delay125s'
                              : 'dialog_box'
                          "
                          v-if="user_activity.cp_info.Cpname"
                        >
                          <div class="ysz"></div>
                          <p class="p_mt">
                            你和<span
                              >{{ user_activity.cp_info.Cpservername }}<br />
                              {{ user_activity.cp_info.Cpname }}</span
                            >结为金兰，<br />
                            互赠鲜花<span>{{
                              formatNumberWithCommas(
                                user_activity.cp_info.Cp_flower_sends
                              )
                            }}</span
                            >朵，<br />快意恩仇<span>{{
                              user_activity.cp_info.Cpdays
                            }}</span
                            >天。
                          </p>
                          <p class="p_mt1">
                            金风玉露寄情谊，<br />跨越人间千万里。
                          </p>
                        </div>
                        <div
                          :class="
                            isAnimateList[6].isPlayAnimate
                              ? 'dialog_box animated fadeIn delay125s'
                              : 'dialog_box'
                          "
                          style="bottom: 17%"
                          v-else
                        >
                          <p>
                            大雪满天地，胡为仗剑游？<br />欲谈心里事，同上酒家楼。<br />阴晴圆缺，邀知己者赏。
                          </p>
                          <p class="p_mt1">大侠，开启义结金兰之旅吧！</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="seventh-act-box">
                      <div
                        :class="
                          isAnimateList[7].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 7"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[7].isPlayAnimate
                              ? 'title animated fadeIn delay125s'
                              : 'title'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[7].isPlayAnimate
                              ? 'server animated fadeIn delay125s'
                              : 'server'
                          "
                        >
                          <div
                            v-for="(item, index) in serverList"
                            :key="index"
                            :class="
                              serverId == item.id ? 'checked' : 'unchecked'
                            "
                            @click="onServerClick(item)"
                          >
                            {{ item.server_name }}
                          </div>
                        </div>
                        <div
                          :class="
                            isAnimateList[7].isPlayAnimate
                              ? 'ranking_list animated fadeIn delay125s'
                              : 'ranking_list'
                          "
                        >
                          <div class="sect_info">
                            <div
                              class="info"
                              v-for="item in sectList"
                              :key="item.id"
                            >
                              <div class="serveName">
                                {{ partnerserverText(item.partnerserver) }}
                              </div>
                              <div :class="'rank rank' + item.rank">
                                {{ item.rank }}
                              </div>
                              <div class="name">{{ item.guildname }}</div>
                              <div class="zq">
                                {{ getLastThreeChars(item.guildserverid) }}
                              </div>
                              <div class="mz">{{ item.guildleadername }}</div>
                              <div class="zl">
                                {{ guildsumfapText(item.guildsumfap) }}
                              </div>
                            </div>
                          </div>
                          <div class="btn">
                            <div class="up" @click="upPageClick"></div>
                            <div class="pageTeam">
                              {{ current_page }}/{{ last_page }}
                            </div>
                            <div class="next" @click="nextPageClick"></div>
                            <div class="inquire" @click="inquireClick"></div>
                            <div class="up_wrap" @click="upPageClick"></div>
                            <div class="next_wrap" @click="nextPageClick"></div>
                            <div
                              class="inquire_wrap"
                              @click="inquireClick"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="eighth-act-box">
                      <div
                        :class="
                          isAnimateList[8].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 8"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[8].isPlayAnimate
                              ? 'inbetweening_left animated fadeIn delay125s'
                              : 'inbetweening_left'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[8].isPlayAnimate
                              ? 'inbetweening_right animated fadeIn delay125s'
                              : 'inbetweening_right'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[8].isPlayAnimate
                              ? 'dialog_box_1 animated fadeIn delay125s'
                              : 'dialog_box_1'
                          "
                        >
                          <div class="ysz"></div>
                          <p class="p_mt">
                            自2023年6月9日开服至今<br />已有<span>5,773,418</span>位大侠参与谱写“仙剑的故事”
                          </p>
                        </div>
                        <div
                          :class="
                            isAnimateList[8].isPlayAnimate
                              ? 'dialog_box_2 animated fadeIn delay125s'
                              : 'dialog_box_2'
                          "
                        >
                          <p>
                            全服共消耗金龙<span>1,087.28亿</span>枚<br />铜币<span>140,771.57亿</span>枚<br />体力<span>223.94亿</span>点<br />共<span>33,215,802</span>只幻灵被捕获<br />最受欢迎的侠客是<span
                              >女娲在世·赵灵儿</span
                            ><br />已被<span>16,019</span>位大侠养成满星2火
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="swiper-slide">
                    <div class="ninth-act-box">
                      <div
                        :class="
                          isAnimateList[9].isPlayAnimate
                            ? 'reel reel-' + isLong + ' showAni-' + isLong
                            : 'reel reel-' + isLong
                        "
                        :style="scaleStyle"
                        v-if="swiperIndex == 9"
                      >
                        <div class="scroll"></div>
                        <div
                          :class="
                            isAnimateList[9].isPlayAnimate
                              ? 'inbetweening animated fadeIn delay125s'
                              : 'inbetweening'
                          "
                        ></div>
                        <div
                          :class="
                            isAnimateList[9].isPlayAnimate
                              ? 'dialog_box animated fadeIn delay125s'
                              : 'dialog_box'
                          "
                        >
                          <p>
                            最受欢迎的侠客是<span>女娲在世·赵灵儿</span
                            ><br />已被<span>16019</span>位大侠<br />养成满星2火
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="swiper-slide">
                    <div class="tenth-act-box">
                      <div
                        :class="
                          isAnimateList[9].isPlayAnimate
                            ? 'paper showAni2'
                            : 'paper'
                        "
                        v-if="swiperIndex == 9"
                      >
                        <!-- <div class="reel"></div> -->
                        <div
                          v-if="
                            user_activity.play_info &&
                            user_activity.play_info != 0
                          "
                        >
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'title animated fadeIn delay-1s'
                                : 'title'
                            "
                          ></div>
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'star animated fadeIn delay-1s'
                                : 'star'
                            "
                          ></div>
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'btn animated fadeIn delay-1s'
                                : 'btn'
                            "
                            @click.stop="isShowShareDialog"
                          ></div>
                        </div>
                        <div v-else>
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'title1 animated fadeIn delay-1s'
                                : 'title1'
                            "
                          ></div>
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'star animated fadeIn delay-1s'
                                : 'star'
                            "
                          ></div>
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'btn1 animated fadeIn delay-1s'
                                : 'btn1'
                            "
                            @click.stop="isShowShareDialog"
                          ></div>
                          <div
                            :class="
                              isAnimateList[9].isPlayAnimate
                                ? 'tips animated fadeIn delay-1s'
                                : 'tips'
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="btn_wrap" v-show="swiperIndex != 0">
                    <div class="decorate_left_up"></div>
                    <div class="leaf_left"></div>
                    <div class="decorate_left_bottom_tree"></div>
                    <div class="decorate_left_bottom_hua"></div>
                    <div class="decorate_right_bottom"></div>
                    <div class="teacup"></div>
                    <div class="leaf"></div>
                    <div class="rebroadcast" @click="backHomepage"></div>
                    <div
                      class="music_btn"
                      v-if="isShowMusicBtn"
                      @click="musicClick(false)"
                    ></div>
                    <div
                      class="close_music_btn"
                      v-if="!isShowMusicBtn"
                      @click="musicClick(true)"
                    ></div>
                    <div class="download_btn" @click="gotoWeb"></div>
                    <div class="logout_btn" @click="openLoginOS"></div>
                    <div class="up-btn" @click.stop="upPage"></div>
                    <div
                      class="next-btn"
                      v-if="swiperIndex != 9"
                      @click.stop="nextPage"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 预加载 -->
        <div
          id="preloading"
          :class="isShow ? 'show' : ''"
          v-show="isShowLoading"
        >
          <div class="mask"></div>
          <div class="logo"></div>
          <div class="line"></div>
          <div class="butterfly"></div>
          <div class="loading"></div>
          <div class="text">
            正在回忆中
            <div class="dots"><span>.</span><span>.</span><span>.</span></div>
          </div>
        </div>

        <!-- 注销弹窗 -->
        <div class="logout-wrap-hjwq popup_wrap1" v-show="logoutShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box-hjwq" v-show="logoutShow">
              <h2>确定退出当前用户</h2>
              <div>
                <a href="javascript:;" @click="logoutShow = false">取消</a>
                <a href="javascript:;" @click="logout()">确认</a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 提示弹窗 -->
        <div :class="'tips-wrap tips-wrap-' + tipsShow">
          <div :class="'show-' + tipsShow2">
            <p>{{ tips }}</p>
          </div>
        </div>

        <!-- 分享弹窗 -->
        <div class="help-share-wrap popup_wrap1" v-show="shareShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="help-share-box popup_wrap-box" v-show="shareShow">
              <div
                class="close-bg"
                v-show="shareShow"
                @click="shareShowClick"
              ></div>
              <img
                :src="shareImg"
                alt="分享图片"
                @touchstart="onTouchStart"
                @touchend="onTouchEnd"
              />
              <div class="tips"></div>
            </div>
          </transition>
        </div>

        <Dialog
          ref="dialogRef"
          @isShowShareImg="isShowShareImg"
          @initShareData="initShareData"
          @getLoginContainer="getLoginContainer"
          @getTeamData="getTeamData"
        ></Dialog>
      </div>

      <!-- 登陆模块 -->
      <Login
        v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        :gameName="gameName"
        :loginTypes="loginTypes"
        downloadUrl="https://hjwq.qingcijoy.com/"
        channelTips="UID可在游戏中—设置—UID查看"
        noAuthLogin
      ></Login>
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancell"
        :gameName="gameName"
      ></Os>

      <!-- 分享相关DOM -->
      <div class="share-box" ref="imageDom">
        <img
          src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/share/bg.png"
        />
        <div :class="roleClass()" v-if="user_activity.play_info"></div>
        <div class="tab"></div>
        <div class="butterfly"></div>
        <div class="name">
          <p>{{ userInfo.server_name }} {{ userInfo.role_name }}</p>
        </div>
        <div class="five_dimensions_wrap">
          <div
            class="five_dimensions"
            id="five_dimensions"
            style="width: 100%; height: 100%"
          ></div>
        </div>
        <div class="info" v-if="user_activity.play_info">
          <div :class="designationClass()"></div>
          <div class="times">
            <p>
              您于<span>{{
                formatDate1(user_activity.play_info.registerdate)
              }}</span
              >来到仙剑世界<br />总在线时长达<span>{{
                formatNumberWithCommas(user_activity.play_info.onlinehours)
              }}</span
              >小时
            </p>
          </div>
          <div class="jinlong">
            ×{{
              formatNumberWithCommas(user_activity.play_info.diamondconsume)
            }}
          </div>
          <div class="tili">
            ×{{ formatNumberWithCommas(user_activity.play_info.vitconsume) }}
          </div>
          <div class="qiyuanfu">
            ×{{
              formatNumberWithCommas(user_activity.play_info.qiyuanfuconsume)
            }}
          </div>
          <div class="wuxishi">
            ×{{
              formatNumberWithCommas(user_activity.play_info.wuxizhaoconsume)
            }}
          </div>
          <div class="xiyouxiake">
            ×{{ formatNumberWithCommas(user_activity.play_info.recruitxiyou) }}
          </div>
          <div class="yinyangxiake">
            ×{{
              formatNumberWithCommas(user_activity.play_info.recruityinyang)
            }}
          </div>
        </div>
        <div class="qrcode-box">
          <!-- <div id="qrcode" class="qrcode"></div> -->
        </div>
      </div>

      <!-- 分享相关DOM(无数据弹窗) -->
      <div class="share-nodata-box" ref="imageDomNoData">
        <img
          src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/nodata_share_dialog.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { Indicator } from "mint-ui";
import Os from "../os";
import Login from "../login";
import { mapState, mapMutations, mapActions } from "vuex";
import { onGetInitDataAPI, shareAPI, getTeamAPI, onLogoutAPI } from "../api";
import { getTimeStamp, buriedLogger } from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";
import Swiper from "swiper";
import Dialog from "../components/dialog.vue";
import "../../../../assets/js/howler";
import "../../../../assets/js/jsmpeg";

export default {
  components: {
    Login,
    Os,
    Dialog,
  },
  data() {
    return {
      gameName: "hjwq",
      logger: null,
      // 其他数据
      loginTypes: ["sms", "password", "channel"],
      user_activity: {},
      user_userInfo: {},
      logoutShow: false,
      // 分享弹窗
      shareShow: false,
      shareImg: "",
      shareLink: "",
      swiper: null,
      // 是否显示预加载弹窗
      isShowLoading: true,
      isShow: false,
      // silder索引
      swiperIndex: 0,
      // 是否要播放动画 isPlayAnimate:是否需要播放动画，isNext是否动画播放完成可以进入下一页
      isAnimateList: [
        { isPlayAnimate: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        // { isPlayAnimate: true, isNext: false }
      ],
      // 区服切换查询仙盟
      serverList: [
        { id: "qf", server_name: "全服" },
        { id: "qcplay", server_name: "官方正式服" },
        { id: "qdf", server_name: "渠道正式服" },
        { id: "bilibili", server_name: "B服" },
        { id: "gzf", server_name: "光子服" },
        { id: "79xqf", server_name: "79先遣服" },
        { id: "qdxqf", server_name: "渠道先遣服" },
      ],
      // 仙盟排序
      sectList: [],
      // 当前选中的区服
      serverId: "qf",
      // 当前仙盟页码
      current_page: 1,
      // 总页码
      last_page: 1,
      // 是否显示万
      isShowMyriad: false,
      //是否是平板
      isTablet: false,
      // 提示语
      tips: "",
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 音乐文件地址
      mp3url: "",
      // 是否显示音乐按钮
      isShowMusicBtn: true,
      // howler自动播放音乐
      hitMusic: {},
      // 缩小卷轴样式
      scaleStyle: "",
      // 横屏长一点的手机
      isLong: false,
      // 仙盟名称
      teamName: "",
      // 页码
      page: 1,
      // 长按事件定时器
      timer: null,
      // 是否已分享
      isShare: false,
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 埋点
    const bl = buriedLogger("hjwq", "仙剑_周年庆");
    this.logger = bl;
    const ua = navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    this.isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua));
  },
  mounted() {
    // 初始化
    this.getLoginContainer();
    this.getTeamData();
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();
      this.swiperInit();
      this.setVideo();
      this.isSetShare();
      this.hitMusic = new Howl({
        preload: true,
        loop: true,
        src: [
          "https://download4.qcplay.com/h5-images/active/hjwq/anniversary/music.mp3",
        ],
      });
      this.hitMusic.play();
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.shareImg = "";
          this.swiperIndex = 0;
          this.serverId = "qf";
          this.teamName = "";
          this.page = 1;
          if (this.swiper) {
            this.swiper.slideTo(0);
          }
        } else if (newValue.role_id !== oldValue.role_id) {
          this.serverId = "qf";
          this.teamName = "";
          this.page = 1;
          // TAG: 初始登陆/切换角色的时候
          this.shareLink = `https://qcg.ink/DoKk63`;
          this.echartsInit();
          window.setTimeout(() => {
            this.initShareData();
          }, 500);
        }
      },
    },
    swiperIndex: {
      handler(newValue, oldValue) {
        if (this.isAnimateList[newValue].isPlayAnimate) {
          setTimeout(() => {
            this.isAnimateList[newValue].isPlayAnimate = false;
            this.isAnimateList[newValue].isNext = true;
          }, 1500);
        }
      },
    },
  },
  methods: {
    swiperInit() {
      this.swiper = new Swiper(".swiper-bg-warp", {
        effect: "fade",
        spaceBetween: 0,
        speed: 500,
      });
    },
    // 上一页
    upPage() {
      if (
        !this.isAnimateList[this.swiperIndex].isPlayAnimate ||
        (this.isAnimateList[this.swiperIndex].isPlayAnimate &&
          this.isAnimateList[this.swiperIndex].isNext)
      ) {
        if (this.user_activity.play_info == 0 && this.swiperIndex === 9) {
          this.isAnimateList[9].isPlayAnimate = true;
          this.swiperIndex = 0;
          this.swiper.slideTo(0);
          return;
        }
        if (
          (!this.user_activity.play_info.petScore ||
            this.user_activity.play_info.petScore == 0) &&
          this.swiperIndex === 5
        ) {
          this.isAnimateList[5].isPlayAnimate = true;
          this.swiperIndex = 3;
          this.swiper.slideTo(3);
        } else {
          this.isAnimateList[this.swiperIndex].isPlayAnimate = true;
          --this.swiperIndex;
          this.swiper.slidePrev();
        }
      }
    },
    // 下一页
    nextPage() {
      if (!this.userInfo.role_name) {
        return this.changeLoginPopup(true);
      }
      if (
        !this.isAnimateList[this.swiperIndex].isPlayAnimate ||
        (this.isAnimateList[this.swiperIndex].isPlayAnimate &&
          this.isAnimateList[this.swiperIndex].isNext)
      ) {
        if (this.user_activity.play_info == 0) {
          this.swiperIndex = 9;
          this.swiper.slideTo(9);
          this.isAnimateList[9].isPlayAnimate = true;
          return;
        }
        if (
          (!this.user_activity.play_info.petScore ||
            this.user_activity.play_info.petScore == 0) &&
          this.swiperIndex === 3
        ) {
          this.swiperIndex = 5;
          this.swiper.slideTo(5);
          this.isAnimateList[3].isPlayAnimate = true;
        } else {
          ++this.swiperIndex;
          this.swiper.slideNext();
          this.isAnimateList[this.swiperIndex - 1].isPlayAnimate = true;
        }
      }
    },
    // 适配
    forceLandscapeScreenHandle() {
      if (document.activeElement.nodeName === "INPUT") return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("triennial-home-page");
      let style = "";
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${
          width / 2
        }px center;width:${height}px;height:${width}px`;
        this.onAdapt(1);
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${
            width / 2
          }px center;width:${width}px;height:${height}px`;
          if (el) el.style = style;
        }, 300);
        this.onAdapt(2);
      }
      document.getElementsByTagName(
        "body"
      )[0].style = `width:${width}px;height:${height}px;font-size:${
        (75 * fontH) / 750
      }px;`;
      if (el) el.style = style;
    },
    onWindowSizeChanged() {
      window.addEventListener("resize", this.forceLandscapeScreenHandle);
    },
    isReloadWindow(event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading() {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
    },
    // 视频播放
    setVideo() {
      let canvas = document.getElementById("canvas");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      let url = "https://download4.qcplay.com/hjwq/ts/demo.ts"; // ts视频地址必须为线上链接
      let player = new window.$JSMpeg.Player(url, {
        canvas: canvas,
        loop: true, // 是否循环，默认false
        autoplay: true, // 是否自动播放，默认false
        onSourceEstablished: () => {
          this.isShow = true;
          setTimeout(() => {
            this.isShowLoading = false;
          }, 500);
        },
        onStalled: (player) => {
          player.stop();
          player.play();
        },
      });
      player.play();
      // player.audioOut.volume 音量设置，默认为1，静音为0
    },
    //小屏自适应 type 1竖屏 2横屏
    onAdapt(type) {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      const aspectRatio = Number((width / height).toFixed(3));
      console.log("aspectRatio", aspectRatio);
      // 竖屏大于0.6就要缩小0.83
      // 横屏小于1.7就要缩小 1.48缩小0.85 1.3缩小0.75  大于2.16就是横屏太长，换背景
      if (type == 1) {
        this.isLong = false;
        if (aspectRatio >= 0.63) {
          this.scaleStyle = "transform-origin: right;transform: scale(0.83);";
        } else {
          this.scaleStyle = "transform-origin: right;transform: scale(1);";
        }
      } else {
        if (aspectRatio < 1.7 && aspectRatio >= 1.48) {
          this.scaleStyle = "transform-origin: right;transform: scale(0.85);";
          this.isLong = false;
        } else if (aspectRatio < 1.48 && aspectRatio >= 1.3) {
          this.scaleStyle = "transform-origin: right;transform: scale(0.75);";
          this.isLong = false;
        } else if (aspectRatio > 2.16) {
          this.scaleStyle = "transform-origin: right;transform: scale(1);";
          this.isLong = true;
        } else {
          this.scaleStyle = "transform-origin: right;transform: scale(1);";
          this.isLong = false;
        }
      }
    },
    // 初始化
    getLoginContainer() {
      Indicator.open();
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.user_activity = response.data.activity;
            this.user_userInfo = response.data.user_info;
            this.$refs.dialogRef.activity = response.data.activity;
            this.$refs.dialogRef.userInfo = response.data.user_info;
            this.onInitDataCallback(response);
            this.setUserInfo(response.data.user_info);
            return;
          }
          // 登录异常
          if (Number(response.code) == 401 && response.data.info) {
            this.onInitDataCallback(response);
            this.tipsMessage("信息加载失败，请先登入游戏", 2000);
            return;
          }
          // 请登录
          if (Number(response.code) == 401) {
            this.onInitDataCallback(response);
            return;
          }
        })
        .finally(() => {
          Indicator.close();
        });
    },
    // 点击区服筛选仙盟
    onServerClick(item) {
      this.serverId = item.id;
      this.$refs.dialogRef.serverName = item.id;
      this.teamName = "";
      this.page = 1;
      this.getTeamData();
    },
    // 仙盟上一页
    upPageClick() {
      if (this.page == 1) {
        return;
      }
      this.page = this.page - 1;
      this.getTeamData();
    },
    // 仙盟下一页
    nextPageClick() {
      if (this.page == this.last_page) {
        return;
      }
      this.page = this.page + 1;
      this.getTeamData();
    },
    // 查找仙盟
    inquireClick() {
      this.$refs.dialogRef.isShowSectDialog = true;
    },
    // 获取仙盟数据
    getTeamData(serverName, teamName) {
      if (serverName || teamName) {
        this.page = 1;
        if (serverName) {
          this.serverId = serverName;
        }
        this.teamName = teamName;
      }
      getTeamAPI({
        team_name: this.teamName,
        partner_server: this.serverId == "qf" ? "" : this.serverId,
        page: this.page,
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.sectList = response.data.data;
          this.current_page = response.data.current_page;
          this.last_page = response.data.last_page;
        } else {
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 大区转文本
    partnerserverText(id) {
      for (let i = 0; i < this.serverList.length; i++) {
        if (this.serverList[i].id == id) {
          return this.serverList[i].server_name;
        }
      }
    },
    // 区服切割
    getLastThreeChars(str) {
      if (str.length > 3) {
        return str.slice(-3);
      }
      return str;
    },
    // 盟战力转文本
    guildsumfapText(guildsumfap) {
      if (guildsumfap >= 100000000) {
        return (guildsumfap / 100000000).toFixed(1) + "亿";
      } else if (guildsumfap >= 10000) {
        return (guildsumfap / 10000).toFixed(1) + "万";
      } else {
        return guildsumfap;
      }
    },
    // 重播事件
    backHomepage() {
      this.swiperIndex = 0;
      this.swiper.slideTo(0);
    },
    // 获取分享奖励
    getShareReward() {
      if (this.user_activity.is_share) {
        return;
      }
      shareAPI().then((response) => {
        if (Number(response.code) == 200) {
          this.logger.sum("仙剑周年_分享获取奖励");
          this.isShare = true;
        }
      });
    },
    // 关闭分享截图弹窗
    shareShowClick() {
      this.shareShow = false;
      if (this.isShare) {
        this.$refs.dialogRef.isShowShareSuccess = true;
        this.isShare = false;
      }
    },
    // 长按 - 点击按钮
    onTouchStart() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        // 长按触发的操作
        this.getShareReward();
      }, 500);
    },
    onTouchEnd() {
      // 手指离开时清除定时器
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    // 打开选择标签弹窗
    isShowTapDialog() {
      this.$refs.dialogRef.isShowTapDialog = true;
    },
    // 跳转到官网
    gotoWeb() {
      window.location.href = "https://hjwq.qingcijoy.com/";
    },
    // 背景音乐点击事件
    musicClick(value) {
      if (value) {
        this.isShowMusicBtn = true;
        this.hitMusic.play();
      } else {
        this.isShowMusicBtn = false;
        this.hitMusic.stop();
      }
    },
    // 打开活动详情弹窗
    isShowActivityDetailDialog() {
      this.$refs.dialogRef.isShowActivityDetail = true;
    },
    // 打开分享报告弹窗
    isShowShareDialog() {
      if (this.user_activity.play_info == 0) {
        this.$refs.dialogRef.isShowShareDialog1 = true;
      } else {
        this.$refs.dialogRef.isShowShareDialog = true;
      }
    },
    // 打开保存分享图片弹窗
    isShowShareImg() {
      this.$refs.dialogRef.isShowShareDialog = false;
      this.$refs.dialogRef.isShowShareDialog1 = false;
      this.shareShow = true;
    },
    // 时间转年月日
    formatDate(time) {
      if (!time) {
        return;
      }
      let date = new Date(time * 1000);
      // 获取年、月、日
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      // 组合成最终的格式
      let formattedDate = [year, month, day];
      return formattedDate;
    },
    // 时间转年月日
    formatDate1(time) {
      if (!time) {
        return;
      }
      let date = new Date(time * 1000);
      // 获取年、月、日
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      // 组合成最终的格式
      let formattedDate = `${year}年${month}月${day}日`;
      return formattedDate;
    },
    // 数字转换
    formatNumberWithCommas(str) {
      if (!str) {
        return "0";
      }
      // 使用正则表达式将字符串从右向左每三个数字分组，并在组之间插入逗号
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 五维图初始化
    echartsInit() {
      const echarts = window.echarts || echarts;
      const chartDom = document.getElementById("five_dimensions");
      const myChart = echarts.init(chartDom);
      const option = {
        color: ["#96cce2"],
        radar: {
          splitNumber: 1,
          indicator: [
            { name: "", max: 5 },
            { name: "", max: 5 },
            { name: "", max: 5 },
            { name: "", max: 5 },
            { name: "", max: 5 },
          ],
          textStyle: {
            color: "#96cce2",
            fontWeight: "bold",
            fontSize: 30,
            fontFamily: "hjwq",
          },
          axisLine: {
            lineStyle: {
              color: "#96cce2",
              width: 1.1,
            },
          },
          splitLine: {
            lineStyle: {
              color: "#96cce2",
              width: 1.1,
            },
          },
          splitArea: {
            areaStyle: {
              color: "transparent",
            },
          },
          center: ["50%", "50%"],
          radius: "100%",
        },
        series: [
          {
            name: "ability",
            type: "radar",
            symbol: "none",
            data: [
              {
                value: [
                  this.fiveDimensionalValue(
                    this.user_activity.max_fap_proportion
                  ),
                  this.fiveDimensionalValue(this.user_activity.maxlayerid),
                  this.fiveDimensionalValue(
                    this.user_activity.diamondconsume_proportion
                  ),
                  this.fiveDimensionalValue(this.user_activity.equipnum),
                  this.fiveDimensionalValue(this.user_activity.CurScore),
                ],
                name: "ability-radar",
                areaStyle: {
                  color: "#fff4cc",
                },
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    // 计算五位图数值
    fiveDimensionalValue(value) {
      let text = 0;
      if (value >= 95) {
        text = 5;
      } else if (65 <= value && value < 95) {
        text = 4.5;
      } else if (35 <= value && value < 65) {
        text = 4;
      } else if (15 <= value && value < 35) {
        text = 3.5;
      } else if (value < 15) {
        text = 3;
      }
      return text;
    },
    // 分享图片标签class判断
    designationClass() {
      if (this.$refs.dialogRef.isShowDescribe1) {
        return (
          "designation designation_1_" + this.$refs.dialogRef.describeIndex1
        );
      } else if (this.$refs.dialogRef.isShowDescribe2) {
        return (
          "designation designation_2_" + this.$refs.dialogRef.describeIndex1
        );
      } else if (this.$refs.dialogRef.isShowDescribe3) {
        return (
          "designation designation_3_" + this.$refs.dialogRef.describeIndex1
        );
      } else if (this.$refs.dialogRef.isShowDescribe4) {
        return (
          "designation designation_4_" + this.$refs.dialogRef.describeIndex1
        );
      }
    },
    // 修改称号更换角色
    roleClass() {
      if (this.$refs.dialogRef.isShowDescribe1) {
        if (this.user_activity.play_info.Gender == 0) {
          return "role role_1_" + this.$refs.dialogRef.describeIndex1;
        } else {
          return "role role_1_" + (this.$refs.dialogRef.describeIndex1 + 6);
        }
      } else if (this.$refs.dialogRef.isShowDescribe2) {
        if (this.user_activity.play_info.Gender == 0) {
          return "role role_2_" + this.$refs.dialogRef.describeIndex1;
        } else {
          return "role role_2_" + (this.$refs.dialogRef.describeIndex1 + 5);
        }
      } else if (this.$refs.dialogRef.isShowDescribe3) {
        if (this.user_activity.play_info.Gender == 0) {
          return "role role_3_" + this.$refs.dialogRef.describeIndex1;
        } else {
          return "role role_3_" + (this.$refs.dialogRef.describeIndex1 + 4);
        }
      } else if (this.$refs.dialogRef.isShowDescribe4) {
        return "role role_4_" + this.$refs.dialogRef.describeIndex1;
      }
    },
    // 初始化分享信息
    initShareData(info) {
      try {
        // this.qrcode(`${this.shareLink}`);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#c1d3e9",
        colorLight: "#59769d",
      });
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(
        this.user_activity.play_info == 0
          ? this.$refs.imageDomNoData
          : this.$refs.imageDom
      )
        .then((canvas) => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功", canvas);
        })
        .catch((err) => {
          console.log("err: 图片生成失败", err.message);
        })
        .finally(() => {
          Indicator.close();
        });
    },
    // 复制链接
    onCopy() {
      const clipboard = new Clipboard("#clipboard-btn");
      clipboard.on("success", (e) => {
        this.tipsMessage("已成功复制分享链接", 2000);
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.tipsMessage("复制失败", 2000);
      });
      this.logger.sum("仙剑周年_复制链接按钮");
    },
    // 退出登录
    logout() {
      onLogoutAPI({ game_id: this.userInfo.game_id }).then((res) => {
        this.logoutShow = false;
        if (res.code === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.$refs.dialogRef.activity = "";
          this.$refs.dialogRef.userInfo = "";
          this.changeLoginPopup(true);
        } else {
          this.tipsMessage(res.msg, 2000);
        }
      });
    },
    selectCallback() {
      this.getLoginContainer();
    },
    osCancell() {
      // 清空数据
      this.getLoginContainer();
    },
    tipsMessage(message, times) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    // 打开登陆弹窗
    openLoginOS() {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
      } else {
        this.logoutShow = true;
      }
    },
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/hjwq/anniversary/enter${getTimeStamp()}`,
        title: "请查收您的年度报告",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/nr3hMmEmIAN1dowBtdwaSDIr05Ad8p4FkPA4mYTf.jpeg",
        desc: "一周年报告来袭，分享获得限定称号！",
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scope>
@import url("./index.less");
.five_dimensions {
  div {
    width: 100% !important;
    height: 100% !important;
    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/anniversary/index/index.vue